import AddItemDialog from "../../Dialogs/AddItemDialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/system/Box";
import { useEffect, useState } from "react";
import { printExam, setCreatePageNumbers, setPrintSolutions } from "../Functions/FunctionsPrint";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { ObjectiveInterface } from "../../../interfaces/examInterfaces";
import { updateExamSettings } from "../Functions/FunctionsMain";

const PrintExamDialog = ({
  open,
  sortedObjectives,
  handleCancel,
}: {
  open: boolean;
  sortedObjectives: ObjectiveInterface[];
  handleCancel: () => void;
}) => {
  const selectedObjectiveId = useSelector((state: RootState) => state.examBuilder.main.selectedObjectiveId);
  const createPageNumbers = useSelector((state: RootState) => state.examBuilder.print.createPageNumbers);
  const printSolutions = useSelector((state: RootState) => state.examBuilder.print.printSolutions);
  const selectedLayout = useSelector((state: RootState) => state.examBuilder.createPages.layoutType);

  const [printSolutionsStored, setPrintSolutionsStored] = useState<boolean>(false);
  const [createPageNumbersStored, setCreatePageNumbersStored] = useState<boolean>(false);

  const user = useSelector((state: RootState) => state.app.user);
  const userId = user?.uid;

  useEffect(() => {
    setPrintSolutionsStored(printSolutions);
    setCreatePageNumbersStored(createPageNumbers);
  }, []);

  function togglePrintSolutions() {
    setPrintSolutions(!printSolutions);
  }

  function toggleCreatePageNumbers() {
    setCreatePageNumbers(!createPageNumbers);
  }

  async function handlePrintExam() {
    console.log({ printSolutions, printSolutionsStored, createPageNumbers, createPageNumbersStored });
    if ((createPageNumbersStored !== createPageNumbers || printSolutionsStored !== printSolutions) && userId) {
      await updateExamSettings(userId, printSolutions, createPageNumbers, selectedLayout);
    }
    if (selectedObjectiveId) {
      printExam(sortedObjectives, selectedObjectiveId, printSolutions, createPageNumbers);
    }
  }

  return (
    <AddItemDialog
      open={open}
      handleCancel={handleCancel}
      handleConfirm={() => handlePrintExam()}
      title={"Prüfung drucken"}
      description={"PDF für den Druck erstellen"}
      confirmText={"PDF erstellen"}
      confirmAllowed={true}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "12px" }}>
        <FormControlLabel
          control={<Checkbox checked={printSolutions} onChange={togglePrintSolutions} />}
          label="PDF Lösungen erstellen"
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <FormControlLabel
          control={<Checkbox checked={createPageNumbers} onChange={toggleCreatePageNumbers} />}
          label="Seitenzahlen einfügen"
        />
      </Box>
    </AddItemDialog>
  );
};

export default PrintExamDialog;
